import AdminUserCart from './AdminUserCart';

export default AdminUserCart;
